module.exports = __webpack_public_path__ + "static/media/icon-defects.7f490b70.svg";